import { DxContainer } from '@dvag/design-system-react';
import { appNames } from '@dvag/dfs-constant-config/app-names';
import { navigateToMicroApp } from '@dvag/dfs-orchestrator-client/navigation';
import { route } from 'config/route';
import { buildPath } from 'service/buildPath';
import { PersonSearchItem } from 'type/person';
import { Loading } from './Loading';
import { MatchedPerson } from './person';

import './style.css';

interface PersonListProps {
  personList: PersonSearchItem[] | undefined;
  isLoading: boolean;
}

export const PersonList = ({ personList, isLoading }: PersonListProps) => {
  const viewPerson = (person: PersonSearchItem) => {
    const path = buildPath(route.placeholder, { selectedPersonId: person.id });
    navigateToMicroApp(appNames.advisor, path);
  };

  if (isLoading) {
    return <Loading />;
  }

  if (!personList?.length) {
    return null;
  }

  return (
    <DxContainer
      className="customer-result-list customer-result-list--search"
      color="white"
      role="list"
    >
      {personList.map((person) => (
        <MatchedPerson key={person.uuid} onClick={() => viewPerson(person)} person={person} />
      ))}
    </DxContainer>
  );
};
